import { render, staticRenderFns } from "./InspectionShipmentList.vue?vue&type=template&id=787bdc6e&scoped=true"
import script from "./InspectionShipmentList.vue?vue&type=script&lang=js"
export * from "./InspectionShipmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787bdc6e",
  null
  
)

export default component.exports